var moduleMap = {
	"./AccountsApp": () => {
		return Promise.all([__webpack_require__.e(7074), __webpack_require__.e(4425), __webpack_require__.e(6151), __webpack_require__.e(7118), __webpack_require__.e(2613), __webpack_require__.e(5297), __webpack_require__.e(5831), __webpack_require__.e(1695), __webpack_require__.e(926), __webpack_require__.e(2699), __webpack_require__.e(2861), __webpack_require__.e(4773), __webpack_require__.e(774), __webpack_require__.e(4816), __webpack_require__.e(3345), __webpack_require__.e(9459)]).then(() => (() => ((__webpack_require__(68449)))));
	},
	"./Version": () => {
		return __webpack_require__.e(1811).then(() => (() => ((__webpack_require__(81811)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});